(() => {
  const scrubVariantId = '48295066140902';
  const scrubHandle = 'cedar-botanical-scrub-bar';
  const deodorantHandles = new Set([
    'cedar-botanical',
    'eucalyptus-marine',
    'lavender-nocturne',
    'sandalwood-chamomile',
    'dark-vanilla',
    'wild-pear',
  ]);
  const setUrl = '/pages/build-your-own-set?add=' + encodeURIComponent(scrubHandle);

  const isScrubForm = form => Boolean(
    form && form.querySelector('input[name="id"][value="' + scrubVariantId + '"]')
  );

  const updateDrawer = async () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + '?sections=cart-drawer,cart-icon-bubble&sections_url=' + encodeURIComponent(location.pathname), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return;
    drawer.renderContents({ sections: await response.json() });
    if (typeof drawer.open === 'function') drawer.open();
  };

  const addToActiveSet = async button => {
    const root = window.Shopify?.routes?.root || '/';
    const cartResponse = await fetch(root + 'cart.js', { credentials: 'same-origin' });
    if (!cartResponse.ok) throw new Error('Could not read cart');
    const cart = await cartResponse.json();
    const hasDeodorant = cart.items.some(item => deodorantHandles.has(item.handle));
    if (!hasDeodorant) {
      window.sessionStorage.setItem('cactus-pending-add', scrubHandle);
      window.location.assign(setUrl);
      return;
    }
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'ADDING…';
    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: Number(scrubVariantId), quantity: 1 }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: location.pathname,
        }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Could not add the scrub');
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(result);
        if (typeof drawer.open === 'function') drawer.open();
      } else {
        await updateDrawer();
      }
    } catch (error) {
      button.textContent = 'TRY AGAIN';
      throw error;
    } finally {
      window.setTimeout(() => {
        button.disabled = false;
        if (button.textContent !== 'TRY AGAIN') button.textContent = original;
      }, 900);
    }
  };

  const makeBundleAction = button => {
    if (!button || button.dataset.cactusBundleOnly) return;
    button.dataset.cactusBundleOnly = 'true';
    if (button.tagName === 'INPUT') button.value = 'ADD TO A SET +';
    else button.textContent = 'ADD TO A SET +';
    button.setAttribute('aria-label', 'Add the Cedar Botanical Scrub Bar to a set');
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      addToActiveSet(button).catch(() => {});
    }, true);
  };

  const lockForm = form => {
    if (!isScrubForm(form)) return;
    makeBundleAction(form.querySelector('button[type="submit"], input[type="submit"]'));
  };

  const lockAll = () => {
    document.querySelectorAll('form').forEach(lockForm);
    document
      .querySelectorAll('[data-cl-add="' + scrubVariantId + '"], [data-cart-recommend="' + scrubVariantId + '"], [data-companion-add="' + scrubVariantId + '"]')
      .forEach(makeBundleAction);
  };

  document.addEventListener('submit', event => {
    if (!isScrubForm(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addToActiveSet(event.target.querySelector('button[type="submit"], input[type="submit"]')).catch(() => {});
  }, true);

  document.addEventListener('click', event => {
    const action = event.target.closest(
      '[data-cl-add="' + scrubVariantId + '"], [data-cart-recommend="' + scrubVariantId + '"], [data-companion-add="' + scrubVariantId + '"]'
    );
    if (!action) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addToActiveSet(action).catch(() => {});
  }, true);

  document.addEventListener('click', event => {
    const legacyBuilderLink = event.target.closest('a[href="/pages/build-a-set"], a[href^="/pages/build-a-set?"]');
    if (!legacyBuilderLink) return;
    event.preventDefault();
    window.location.assign(legacyBuilderLink.href.replace('/pages/build-a-set', '/pages/build-your-own-set'));
  }, true);

  document.addEventListener('DOMContentLoaded', lockAll);
  new MutationObserver(lockAll).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
  lockAll();
})();

/* CACTUS cart offer: server discount codes remain the source of truth. */
(() => {
  const handles = new Set(['cedar-botanical','eucalyptus-marine','lavender-nocturne','sandalwood-chamomile','dark-vanilla','wild-pear']);
  const deoVariants=new Set(['48294986449126','48294995427558','48295003586790','48295006208230','48294992937190','48294900596966']);
  const isDeo=item=>handles.has(item.handle)||deoVariants.has(String(item.variant_id||item.id));
  const gifts = new Set(['the-cactus-gift','the-full-cactus']);
  const baseFetch = window.fetch.bind(window);
  const root = () => window.Shopify?.routes?.root || '/';
  let queue = Promise.resolve();
  const readCart = async () => {
    const response = await baseFetch(root()+'cart.js', {credentials:'same-origin'});
    if(!response.ok) throw Error('Could not check your bag. Please try again.');
    return response.json();
  };
  const synchronize = (sectionIds=['cart-drawer','cart-icon-bubble']) => {
    const run = async () => {
      const cart = await readCart();
      const hasGift = cart.items.some(item => gifts.has(item.handle) || item.properties?._cactus_gift);
      const quantity = cart.items.reduce((sum,item) => sum + (isDeo(item) && !item.properties?._cactus_gift ? item.quantity : 0),0);
      // Full-price gift boxes do not participate in the multi-deodorant offer.
      const code = quantity>=3 && quantity<=6 ? 'CACTUS-DEO-'+quantity : '';
      const response = await baseFetch(root()+'cart/update.js',{
        method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({discount:code,sections:sectionIds.slice(0,5),sections_url:location.pathname})
      });
      const result=await response.json();
      if(!response.ok) throw Error(result.description || 'Could not apply your set offer. Please try again.');
      result._cactusChanged = cart.total_price !== result.total_price;
      return result;
    };
    queue=queue.catch(()=>{}).then(run);
    return queue;
  };
  const prepare = async () => {
    const cart=await synchronize();
    const hasDeo=cart.items.some(item=>isDeo(item)||gifts.has(item.handle)||item.properties?._cactus_gift);
    if(cart.items.some(item=>item.handle==='cedar-botanical-scrub-bar')&&!hasDeo) throw Error('The scrub bar is a set add-on. Add a deodorant or remove the scrub before checkout.');
    return cart;
  };
  window.CactusCart={prepare,synchronize};
  window.fetch=async (...args)=>{
    const response=await baseFetch(...args);
    const url=typeof args[0]==='string'?args[0]:args[0]?.url||'';
    if(!response.ok||!/\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/.test(url)) return response;
    try{
      const original=await response.clone().json();
      const requestedSections=Object.keys(original.sections||{});
      const cart=await synchronize(requestedSections.length?requestedSections:undefined);
      const result=/\/cart\/add(?:\.js)?(?:\?|$)/.test(url)?{...original,sections:cart.sections}:cart;
      return new Response(JSON.stringify(result),{status:response.status,statusText:response.statusText,headers:response.headers});
    }catch(error){
      console.error('CACTUS set offer:',error.message);
      return response;
    }
  };
  let checking=false;
  const checkoutAction=async (event,form,button)=>{
    if(form.dataset.cactusCheckoutReady==='true')return;
    event.preventDefault();event.stopImmediatePropagation();
    if(checking)return;checking=true;
    if(button)button.disabled=true;
    try{
      await prepare();form.dataset.cactusCheckoutReady='true';
      if(button)button.disabled=false;
      form.requestSubmit(button||undefined);
    }catch(error){
      let status=form.querySelector('[data-cactus-checkout-error]');
      if(!status){status=document.createElement('p');status.dataset.cactusCheckoutError='';status.setAttribute('role','alert');form.append(status);}
      status.textContent=error.message;status.scrollIntoView({block:'nearest'});
    }finally{checking=false;if(button)button.disabled=false;}
  };
  document.addEventListener('click',event=>{
    const button=event.target.closest('button[name="checkout"],input[name="checkout"]');
    if(button?.form)checkoutAction(event,button.form,button);
  },true);
  document.addEventListener('submit',event=>{
    if(event.submitter?.name==='checkout')checkoutAction(event,event.target,event.submitter);
  },true);
  if(location.pathname === root()+'cart') synchronize().then(cart=>{if(cart._cactusChanged) location.reload();}).catch(error=>console.error(error.message));
})();
